export default [
  { title: "Beranda", icon: "ri-home-4-line", link: "/dashboard" },
  // { title: "Deposit", icon: "ri-wallet-line", link: "/deposit" },
  // { title: "Report", icon: "ri-file-edit-line", link: "/" },
];
